import { Map, List, fromJS } from 'immutable';
import { IAction } from '@/types/redux';
import { IToast } from '@/types/toast';

const initialState = fromJS({
  queue: [],
  activeToast: null,
});

function toastrReducer(state = initialState, action: IAction) {
  const toast: IToast = action.payload;
  const queue: List<IToast> = state.get('queue');

  switch (action.type) {
    case 'TOASTR_QUEUE':
      return state.set('queue', queue.push(toast));

    case 'TOASTR_SHOW':
      return state.set('activeToast', toast).set('queue', queue.delete(queue.indexOf(toast)));

    case 'TOASTR_HIDE_ACTIVE':
      return state.set('activeToast', null);

    case 'TOASTR_RESET':
      return initialState;

    default:
      return state;
  }
}

export default toastrReducer;
